import { createSelectorHook } from '@redux-basic-module/hooks-utils';

import { selectors } from './reducer';

export const usePersistedStoredFinalized = createSelectorHook(
  selectors.finalized,
);
